<script>
import { BCardTitle, BListGroup, BListGroupItem, BCard, BRow, BCol, BFormGroup, BButton,
    BFormInput } from 'bootstrap-vue'
import vSelect from 'vue-select'
import {SubstanceLists} from "@/libs/substance";

export default {
    components: {
        BCard, BButton, BRow, BCol, BFormGroup, BCardTitle, vSelect, BFormInput, BListGroup, BListGroupItem,
    },
    props: {
        readOnly: {
            default: false,
        },
        compactView: {
            default: false
        },
        concentrationRangeIntervalOptions: {
            default() {
                return [];
            }
        },
        substance: {
            required: true,
            type: Object,
        },
        details: {
            required: true,
            type: Array,
        }
    },
    data() {
        return {
            exemption: this.getExemption(),
            maxConcentrationRange: this.getMaxConcentration(),
            concentrationRange: this.getConcentrationRange(),

            suggestions: [],
            searchTimer: null,
            inputProps: {
                class: 'form-control w-100',
            },

            timeoutId: null
        };
    },
    methods: {
        getExemption() {
            return this.details.length ? this.details[0].exemption : ''
        },
        getConcentrationRange() {
            let range = null;
            this.details
                .filter(d => d.concentrationRange)
                .forEach(d => {
                    if (!range || range.priority < d.concentrationRange.priority) {
                        range = d.concentrationRange;
                    }
                });

            return range;
        },
        getMaxConcentration() {
            return Math.max(...this.details
                .filter(details => details.maxConcentration)
                .map(details => details.maxConcentration))
        },
        exclude(substance) {
            this.$emit('exclude', substance);
        },
        normalize(node) {
            return {id: node.id, label: node.title};
        },

        onExemption(value) {
            clearTimeout(this.timeoutId);
            this.timeoutId = setTimeout(() => {
                this.emit();
            }, 500);
        },

        onMaxConcentrationRangeChange(value) {
            this.emit();
        },

        onConcentrationRangeChange(value) {
            this.concentrationRange = value;
            this.emit();
        },

        emit() {
            this.$emit('change', SubstanceLists.ROHS, [{
                exemption: this.exemption,
                concentrationRange: this.concentrationRange,
                maxConcentration: this.maxConcentrationRange ? parseFloat(this.maxConcentrationRange) : null,
            }]);
        },
    },
    watch: {
        details() {
            this.maxConcentrationRange = this.getMaxConcentration();
            this.concentrationRange = this.getConcentrationRange();
            this.exemption = this.getExemption();
        }
    }
}
</script>

<template>
    <div>
        <b-row v-if="compactView" class="pl-2 pr-2">
            <b-col>
                <b-row>
                    <b-col md="4" lg="4" sm="2">
                        <b-form-group :label="$t('Component(CompositionSubstance):max-concentration')">
                            <b-form-input
                                :title="$t('Component(CompositionSubstance):hover-max-concentration')"
                                v-model="maxConcentrationRange"
                                type="number"
                                :disabled="readOnly"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="8" lg="8" sm="10">
                        <b-form-group :label="$t('Component(CompositionSubstance):scip-interval')">
                            <v-select
                                v-model="concentrationRange"
                                label="title"
                                class="input-bg-warning"
                                :title="$t('Component(CompositionSubstance):hover-scip-interval')"
                                :options="concentrationRangeIntervalOptions"
                                @input="onConcentrationRangeChange"
                                :placeholder="$t('Component(CompositionSubstance):scip-interval-placeholder')"
                                :disabled="readOnly"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group :label="$t('Component(CompositionSubstance):rohs-exemption')">
                            <b-form-input
                                v-model="exemption"
                                :title="$t('Component(CompositionSubstance):hover-rohs-exemption')"
                                :placeholder="$t('Component(Placeholder):type-here')"
                                @input="onExemption"
                                :disabled="readOnly"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row v-else class="pl-2 pr-2">
            <b-col md="5" lg="5">
                <b-row>
                    <b-col md="4" lg="4" sm="2">
                        <b-form-group :label="$t('Component(CompositionSubstance):max-concentration')">
                            <b-form-input
                                v-model="maxConcentrationRange"
                                :title="$t('Component(CompositionSubstance):hover-max-concentration')"
                                type="number"
                                @input="onMaxConcentrationRangeChange"
                                :disabled="readOnly"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="8" lg="8" sm="10">
                        <b-form-group :label="$t('Component(CompositionSubstance):scip-interval')">
                            <v-select
                                v-model="concentrationRange"
                                label="title"
                                class="input-bg-warning"
                                :title="$t('Component(CompositionSubstance):hover-scip-interval')"
                                :options="concentrationRangeIntervalOptions"
                                @input="onConcentrationRangeChange"
                                :placeholder="$t('Component(CompositionSubstance):scip-interval-placeholder')"
                                :disabled="readOnly"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-col>
            <b-col md="7" lg="7">
                <b-row>
                    <b-col>
                        <b-form-group :label="$t('Component(CompositionSubstance):rohs-exemption')">
                            <b-form-input
                                v-model="exemption"
                                :title="$t('Component(CompositionSubstance):hover-rohs-exemption')"
                                :placeholder="$t('Component(Placeholder):type-here')"
                                @input="onExemption"
                                :disabled="readOnly"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>
